// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date
import moment from 'moment';
import {SaltusAny} from './SaltusAny';

export const newUTCDate = (...props: SaltusAny): Date => {
  return moment.utc(...props).toDate();
};
